import { downloadCsv } from '../../../lib/downloadBlob';
import type { PublisherDashboardInventoryRow } from './model';

export function downloadPublisherInventoryCsv(rows: PublisherDashboardInventoryRow[]) {
  const headings = [
    'App bundle ID',
    'Domain',
    'Ad requests',
    'Ad impressions',
    'Ad Requests Filled',
    'Revenue share IO',
    'Revenue',
  ];
  const csv = [
    headings,
    ...rows.map((row) => [
      row.appBundleId ?? '',
      row.domain ?? '',
      row.adRequests ?? 0,
      row.pubAdImpressions ?? 0,
      row.adRequestsFilled ?? 0,
      row.pubRevenueShareIo ?? 0,
      row.pubRevenue ?? 0,
    ]),
  ]
    .map((values) => values.map(csvCell).join(','))
    .join('\n');
  downloadCsv(csv, 'AppsDomains.csv');
}
function csvCell(value: string | number) {
  const text = String(value);
  return /[",\n]/.test(text) ? `"${text.replaceAll('"', '""')}"` : text;
}
